import { Box } from "@mui/material";
import { useEffect } from "react";
import cookie from "react-cookies";
import { useParams } from "react-router-dom";
import { postQuickSightReport } from "../../api/quickSite";
import { RIMS_COOKIE_STG_CONSTANTS, RIMS_SESSION_STG_CONSTANTS } from "../../constants";
const QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");

const QuickSightReport = (props: any): JSX.Element => {
  const params = useParams();
  const tenantId =
      sessionStorage.getItem(RIMS_SESSION_STG_CONSTANTS.CURRENT_TENANT_ID) ||
      cookie.load(RIMS_COOKIE_STG_CONSTANTS.USER_TENANT_ID);

  useEffect(() => {
    let dashboardExperience: any | undefined;
    let containerDiv: HTMLElement | null = null;

    const run = async () => {
      try {
        if (!params.id) return;

        const { createEmbeddingContext } = QuickSightEmbedding;

        containerDiv = document.getElementById("embeddingContainer");
        if (!containerDiv) return;
        containerDiv.innerHTML = "";

        const embeddingContext = await createEmbeddingContext();

        const embedAPIReturn = await postQuickSightReport({
          dashboardID: params.id,
          token: cookie.load(RIMS_COOKIE_STG_CONSTANTS.LOGIN_TOKEN),
          privilege: [
            {
              MenuName: "Tenantid",
              isAllDataAvailable: false,
              DataValues: [tenantId]
            }
          ]
        })
        const embedUrl = embedAPIReturn.data;

        const frameOptions = {
          url: embedUrl,
          container: containerDiv,
          scrolling: "no",
          height: `${window.innerHeight - 120}px`,
          width: "100%",
          resizeHeightOnSizeChangedEvent: false,
          withIframePlaceholder: true,
        };

        const contentOptions = {
          locale: "en-US",
          toolbarOptions: {
            export: true,
            undoRedo: false,
            reset: false,
          },
          attributionOptions: {
            overlayContent: false,
          },
        };

        dashboardExperience = await embeddingContext.embedDashboard(
          frameOptions,
          contentOptions
        );
      } catch (error) {
        console.error("Error embedding QuickSight report:", error);
      }
    };

    run();

    return () => {
      try {
        dashboardExperience?.close?.();
      } catch {
      }
      if (containerDiv) containerDiv.innerHTML = "";
    };
  }, [params.id]);

  return (
    <div className="quick-sight-page reportBox">
      <Box sx={{ width: "100%", typography: "body1" }}>
        <div id="embeddingContainer"></div>
      </Box>
    </div>
  );
};

export default QuickSightReport;
